var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59961 4.19961C7.59961 4.53098 7.33098 4.79961 6.99961 4.79961C6.66824 4.79961 6.39961 4.53098 6.39961 4.19961C6.39961 3.86824 6.66824 3.59961 6.99961 3.59961C7.33098 3.59961 7.59961 3.86824 7.59961 4.19961Z",
    fill: "#1271A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99961 5.59961C7.33098 5.59961 7.59961 5.86824 7.59961 6.19961V9.79961C7.59961 10.131 7.33098 10.3996 6.99961 10.3996C6.66824 10.3996 6.39961 10.131 6.39961 9.79961V6.19961C6.39961 5.86824 6.66824 5.59961 6.99961 5.59961Z",
    fill: "#1271A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3996 6.99961C13.3996 10.5342 10.5342 13.3996 6.99961 13.3996C3.46499 13.3996 0.599609 10.5342 0.599609 6.99961C0.599609 3.46499 3.46499 0.599609 6.99961 0.599609C10.5342 0.599609 13.3996 3.46499 13.3996 6.99961ZM12.1996 6.99961C12.1996 9.87149 9.87149 12.1996 6.99961 12.1996C4.12773 12.1996 1.79961 9.87149 1.79961 6.99961C1.79961 4.12773 4.12773 1.79961 6.99961 1.79961C9.87149 1.79961 12.1996 4.12773 12.1996 6.99961Z",
    fill: "#1271A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPrimary);
export default __webpack_public_path__ + "static/media/infoPrimary.9946cb79e27202c57ca49f617e84e933.svg";
export { ForwardRef as ReactComponent };